import React, { Component, ComponentType, ErrorInfo } from 'react';
import { Logger } from '@mineko/js-browser-core';
import ErrorFallback from './ErrorFallback';

type Props = {
  children?: any;
  renderError?: (props: { error: Error; errorInfo: any }) => any;
};

type State = {
  error?: Error;
  errorInfo?: ErrorInfo;
};

class ErrorBoundary extends Component<Props, State> {
  state: State = { error: undefined, errorInfo: undefined };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    Logger.logException(error);
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    const { children, renderError } = this.props;
    const { error, errorInfo } = this.state;

    if (error && errorInfo) {
      if (renderError) return renderError({ error, errorInfo });

      return <ErrorFallback error={error} componentStack={JSON.stringify(errorInfo)} eventId="1" />;
    }

    return <>{children}</>;
  }
}

export default ErrorBoundary as ComponentType<Props>;
